function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import AllhomesListingSection from '../listing-section/allhomes-listing-section';
import * as styles from './documents.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Documents = _ref => {
  var title = _ref.title,
    documents = _ref.documents;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var documentsWithKeys = documents.map((item, index) => _objectSpread(_objectSpread({}, item), {}, {
    keyIndex: index
  }));
  var renderDocumentLinks = documentsWithKeys.map(document => ___EmotionJSX("a", {
    css: styles.link,
    key: document.keyIndex,
    href: getAbsoluteUrl(document.downloadUrl)
  }, document.label));
  return ___EmotionJSX(AllhomesListingSection, {
    title: title
  }, renderDocumentLinks);
};
Documents.propTypes = {
  title: PropTypes.string,
  documents: PropTypes.arrayOf(PropTypes.shape({
    downloadUrl: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired
};
Documents.defaultProps = {
  title: 'Documents'
};
export default Documents;